<template>
    <div>
        <!-- não exibe para dispositivos moveis -->
        <div class="mt-4 d-none d-xl-block">
            <div class="row mt-4">
                <div class="tab_h col-md-1 col-xl-1 ml-5"  :class="tabSelecionado == 1 ? 'cssTabHSelecionado' : ''"></div>
            </div>
        
            <div class="row">
                <div class="col-md-1 tab_protesto ml-5 text-center" :class="tabSelecionado == 1 ? 'cssTabSelecionado' : ''">
                    <div class="textoTab" @click="selecionaTab(1)">PROTESTO</div>
                </div>
            </div>
        </div>
        <!-- não exibe para dispositivos moveis -->
    
        <!-- exibe para dispositivos moveis -->
        <div class="row d-xl-none">
            <div class="tab_h_m col-10 ml-5" :class="tabSelecionado == 1 ? 'cssTabHSelecionado' : ''"></div>
            <div class="col-10 tab_protesto_m ml-5 text-center" :class="tabSelecionado == 1 ? 'cssTabSelecionado' : ''">
                <div class="textoTab_m" @click="selecionaTab(1)">PROTESTO</div>
            </div>
        </div>
        <!-- exibe para dispositivos moveis -->
    </div>
</template>
<script>
export default {
    data() {
        return {
            tabSelecionado:'1',
            cssTabSelecionado : {
                'background-color': "rgb(55,170,255)",
                'color': 'white',
                'width': '30%',
                'height':'auto'
            },
             cssTabHSelecionado : {
                'background-color': 'rgb(64,207,257)' ,
                'height':'0.4vh',
                'width': '30%'
             }
        }
    },
    methods: {
        selecionaTab: function(tab){
            this.tabSelecionado = tab
            this.$emit('alteraTab',tab);
        }
    }
    
}
</script>
<style scoped>
.textoTab{
    font-size: 14px;
    font-weight: bold;
    color: #fff;
    cursor: pointer;
    padding: 10px 15px; /*ADICIONADO*/
    width:100%; /*ADICIONADO*/
    height: 100%; /*ADICIONADO*/
    display: flex; /*ADICIONADO*/
    justify-content: center; /*ADICIONADO*/
    align-items: center; /*ADICIONADO*/
    font-family: 'Kanit', sans-serif; /*ADICIONADO*/
}
.textoTab_m{
    font-size: 12px;
    font-weight: bold;
    color: #fff;
    /* margin-top: 10px; */ /*REMOVIDO*/
    cursor: pointer;
    font-family: 'Kanit', sans-serif; /*ADICIONADO*/
    width: 100%; /*ADICIONADO*/
    height: 100%; /*ADICIONADO*/
    justify-content: center; /*ADICIONADO*/
    align-items: center; /*ADICIONADO*/
    display: flex; /*ADICIONADO*/
}

.tab_h{
   /* background-color: rgb(66,90,104); */ /*REMOVIDO*/
   background-color: rgb(64,67,67);
   height:0.4vh;  
   opacity: 0.7;
}

.tab_protesto{
   /* background-color: rgb(66,90,104); */ /*REMOVIDO*/
   background-color: rgb(64,67,67); /*ADICIONADO*/
   padding:0; /*ADICIONADO*/
   height:auto;
}
.tab_protesto_anuencia{
  /* background-color: rgb(66,90,104); */ /*REMOVIDO*/
   background-color: rgb(64,67,67); /*ADICIONADO*/
   padding:0; /*ADICIONADO*/
  /* padding: 0.1px;*/ /*REMOVIDO*/
  /* opacity: 0.9; */ /*REMOVIDO*/
  line-height: 16px;
  /* margin-left: 3px; */ /*REMOVIDO*/
}
.tab_edital{
  /* background-color: rgb(66,90,104); */ /*REMOVIDO*/
   background-color: rgb(64,67,67); /*ADICIONADO*/
   padding:0; /*ADICIONADO*/
  /* margin-left: 3px; */ /*REMOVIDO*/
  /* opacity: 0.9; */ /*REMOVIDO*/
  line-height: 16px;
}
.tab_protesto_m{
    background-color: rgb(66,90,104);
    background-color: rgb(64,67,67);
    color: white;
    width: 30%;
    height:4.75vh;
    opacity: 0.7;   
    display: flex; /*ADICIONADO*/
    justify-content: center; /*ADICIONADO*/
    align-items: center; /*ADICIONADO*/

}
.tab_protesto_anuencia_m{
  background-color: rgb(66,90,104);
   background-color: rgb(64,67,67);
  padding: 0.1px;
  opacity: 0.7;
  line-height: 16px;
  height:4.75vh;
  /* margin-left: 3px; */   
    display: flex; /*ADICIONADO*/
    justify-content: center; /*ADICIONADO*/
    align-items: center; /*ADICIONADO*/
}
.tab_edital_m{
  background-color: rgb(66,90,104);
   background-color: rgb(64,67,67);
  /* margin-left: 3px; */
  opacity: 0.7;
  line-height: 16px;
  height:4.75vh;   
    display: flex; /*ADICIONADO*/
    justify-content: center; /*ADICIONADO*/
    align-items: center; /*ADICIONADO*/
}
.tab_h_m{
   background-color:rgb(66,90,104);
   background-color: rgb(64,67,67);
   height:0.2vh;
   opacity: 0.8;   
    display: flex; /*ADICIONADO*/
    justify-content: center; /*ADICIONADO*/
    align-items: center; /*ADICIONADO*/
}


.cssTabSelecionado {
    background-color: rgb(55,170,255);
    color: white;
    width: 30%;
    height:auto;
}
.cssTabHSelecionado {
    background-color: rgb(64,207,257);
    height:0.4vh;
    width: 30%;
}


 .row > .tab_protesto_m {
    margin:0px !important;
  }
</style>